import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "steps" }
const _hoisted_2 = {
  key: 0,
  class: "step__basic"
}
const _hoisted_3 = { class: "left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите фамилию", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите имя", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите должность", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "В лице кого подаём. Пример: Генерального директора", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите ФИО в родительном падеже", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "В лице кого подаём. Пример: Иванова Ивана Ивановича", -1)
const _hoisted_10 = {
  class: "right",
  style: {"padding-top":"15px","gap":"0rem"}
}
const _hoisted_11 = { for: "title" }
const _hoisted_12 = { class: "gender" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "gender" }, "Выберите пол", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Загрузите или перенесите сюда файл подписи", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Подпись должны быть в формате png, размером не менее 100 × 100 px", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Перенесите сюда "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" подпись или нажмите "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" для загрузки")
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Перенесите сюда "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" подпись или нажмите "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" для загрузки")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "step__basic"
}
const _hoisted_21 = { class: "left" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите серию паспорта", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: 2212", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите номер паспорта", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: 999654", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Дата выдачи", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: 20.02.2002", -1)
const _hoisted_28 = { class: "right" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Кем выдан паспорт", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: Отделом УФМС России по гор. Москва по району Митино", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Код подразделения", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: 770-093", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Где зарегистрирован", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: г. Москва, ул. Ленина, д. 74, кв. 105", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass({activeStep: _ctx.subpage == 1}),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.subpage = 1))
      }, "Шаг 1", 2),
      _createElementVNode("button", {
        class: _normalizeClass({activeStep: _ctx.subpage == 2}),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.subpage = 2))
      }, "Шаг 2", 2)
    ]),
    (_ctx.subpage == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _hoisted_4,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Введите фамилию",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.document.declarer_lastname) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.declarer_lastname]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Введите имя",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.document.declarer_firstname) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.declarer_firstname]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_6,
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Введите должность",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.client_role) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.client_role]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Введите ФИО в родительном падеже",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.document.client_role_fio_genitive) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.client_role_fio_genitive]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("section", null, [
              _createElementVNode("label", _hoisted_11, [
                _createVNode(_component_v_switch, {
                  style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
                  color: "#2F80ED",
                  modelValue: _ctx.document.declarer_patronymic_no,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.document.declarer_patronymic_no) = $event)),
                  label: "Отчество"
                }, null, 8, ["modelValue"])
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "input lastname",
                style: {"margin-top":"-0.6rem"},
                type: "text",
                placeholder: "Введите отчество",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.document.declarer_patronymic) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.declarer_patronymic]
              ])
            ]),
            _createElementVNode("section", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_v_radio_group, {
                modelValue: _ctx.document.declarer_genre,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.document.declarer_genre) = $event)),
                inline: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_radio, {
                    color: "#2F80ED",
                    label: "Мужчина",
                    value: "1"
                  }),
                  _createVNode(_component_v_radio, {
                    color: "#2F80ED",
                    label: "Женщина",
                    value: "2"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("section", null, [
              _hoisted_14,
              _hoisted_15,
              _createElementVNode("input", {
                ref: "signature_file",
                type: "file",
                hidden: "",
                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.submitFile('signature_file')))
              }, null, 544),
              (_ctx.document.signature_file != '')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "uploadFile",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$refs.signature_file.click())),
                    style: _normalizeStyle('background: url(\'https://api.rekprof.ru/files/'+_ctx.document.signature_file+'\'); background-position: center; background-size: contain; background-repeat: no-repeat; border: 1px solid black;')
                  }, _hoisted_17, 4))
                : _createCommentVNode("", true),
              (_ctx.document.signature_file == '')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "uploadFile",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$refs.signature_file.click()))
                  }, _hoisted_19))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.subpage == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", null, [
              _hoisted_22,
              _hoisted_23,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "0000",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.document.declarer_passport_seria) = $event)),
                maxlength: "4",
                onkeypress: "return (event.charCode >= 48 && event.charCode <= 57)"
              }, null, 512), [
                [_vModelText, _ctx.document.declarer_passport_seria]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_24,
              _hoisted_25,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "000000",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.document.declarer_passport_number) = $event)),
                maxlength: "6",
                onkeypress: "return event.charCode >= 48 && event.charCode <= 57"
              }, null, 512), [
                [_vModelText, _ctx.document.declarer_passport_number]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_26,
              _hoisted_27,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "date",
                placeholder: "__.__.____",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.document.declarer_when_issued) = $event)),
                maxlength: "10",
                onkeypress: "return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46"
              }, null, 512), [
                [_vModelText, _ctx.document.declarer_when_issued]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", null, [
              _hoisted_29,
              _hoisted_30,
              _withDirectives(_createElementVNode("textarea", {
                style: {"resize":"none","overflow":"hidden"},
                class: "input",
                type: "text",
                placeholder: "Введите учреждение",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.document.declarer_passport_issued) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.declarer_passport_issued]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_31,
              _hoisted_32,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "000-000",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.document.declarer_division_code) = $event)),
                maxlength: "6",
                onkeypress: "return (event.charCode >= 48 && event.charCode <= 57)",
                pattern: "[0-9]{3}-[0-9]{3}"
              }, null, 512), [
                [_vModelText, _ctx.document.declarer_division_code]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_33,
              _hoisted_34,
              _withDirectives(_createElementVNode("textarea", {
                style: {"resize":"none","overflow":"hidden"},
                class: "input",
                type: "text",
                placeholder: "Введите адрес регистрации",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.document.declarer_passport_registration) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.declarer_passport_registration]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}